// extracted by mini-css-extract-plugin
export default {"rootGroup":"rootGroup__1CJyb","nameGroup":"nameGroup__5OmZ4","categoryTitle":"categoryTitle__JoGs6","collapsedIcon":"collapsedIcon__xydGf"};